import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { INPUT_TITLE_MAP } from '../inputs'
import styles from './InputRow.module.scss'

const propTypes = {
  /**
   * Input name
   */
  input: PropTypes.string.isRequired,
  /**
   * callback to decide if input should be displayed or not
   * If return true, input is displayed
   */
  displayInput: PropTypes.func,
  /**
   * Function to render input. Should return a react node. Params: input
   */
  renderInput: PropTypes.func.isRequired,
  /**
   * Optional renderer for content displayed next to the input label
   */
  renderLabelAction: PropTypes.func,
  /**
   * If true, make the label (title) of item bold
   */
  labelBold: PropTypes.bool,
  /**
   * Briefly mark a field that was just added
   */
  highlighted: PropTypes.bool,
}

function InputRow(props) {
  const {
    input,
    displayInput = () => true,
    renderInput,
    renderLabelAction = () => null,
    labelBold = false,
    highlighted = false,
  } = props ?? {}

  if (!displayInput(input)) {
    return null
  }

  const messageId = INPUT_TITLE_MAP[input]
  const labelAction = renderLabelAction(input)

  return (
    <Row id={`policy-field-${input}`} className={clsx('mb-3', highlighted && styles.highlighted)}>
      <Col md="5" className={clsx('d-flex align-items-start', labelBold && 'text-bold')}>
        {messageId && (
          <span>
            <FormattedMessage id={messageId} />
          </span>
        )}
        {labelAction && <span className="ms-2 d-inline-flex align-items-center">{labelAction}</span>}
      </Col>
      <Col md="7">{renderInput(input)}</Col>
    </Row>
  )
}

InputRow.propTypes = propTypes

export default InputRow
